/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface MetierConseillersLiesSearch
 */
export interface MetierConseillersLiesSearch {
    /**
     * 
     * @type {number}
     * @memberof MetierConseillersLiesSearch
     */
    idmetier?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof MetierConseillersLiesSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof MetierConseillersLiesSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof MetierConseillersLiesSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MetierConseillersLiesSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof MetierConseillersLiesSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof MetierConseillersLiesSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the MetierConseillersLiesSearch interface.
 */
export function instanceOfMetierConseillersLiesSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MetierConseillersLiesSearchFromJSON(json: any): MetierConseillersLiesSearch {
    return MetierConseillersLiesSearchFromJSONTyped(json, false);
}

export function MetierConseillersLiesSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): MetierConseillersLiesSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idmetier': !exists(json, 'idmetier') ? undefined : json['idmetier'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function MetierConseillersLiesSearchToJSON(value?: MetierConseillersLiesSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idmetier': value.idmetier,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

